module.exports = __webpack_public_path__ + "2b97dd188c6f48b9b7c10a65e6b36cf2.jpg";